import styled from 'styled-components'

const StyledSidebarPrompt = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: rgba(10, 13, 23, 0.85);
  font-family: ${({ theme }) => theme.fonts.lexend};
  display: none;

  .prompt .tip {
    padding: 12px;
    background: #DDE2E5;
    display: flex;
    border-radius: 5px;
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.gray[700]};
    font-weight: 500;
    
    svg {
      height: 24px;
      flex-shrink: 0;
      margin-right: 12px;
    }
  }

  a {
    font-family: ${({ theme }) => theme.fonts.lexend};

    button {
      margin-top: 1rem;
      width: 100%;
      background-color: ${({ theme }) => theme.colors.background};
      color: ${({ theme }) => theme.colors.gray[900]};
      font-weight: 500;
  
      &:hover {
        background-color: ${({ theme }) => theme.colors.gray[200]};
      }
    }
  }
`

export default StyledSidebarPrompt
